import { BaseService } from "./BaseService";
import {
  AdminSubscriptionTransactionFilters,
  AdminSubscriptionTransactionListResponse,
} from "@/types/subscription-transactions";

function toQueryParams(
  filters?: AdminSubscriptionTransactionFilters,
): Record<string, string> | undefined {
  if (filters === undefined) {
    return undefined;
  }

  const params = Object.fromEntries(
    Object.entries(filters)
      .filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      )
      .map(([key, value]) => [key, String(value)]),
  );

  return Object.keys(params).length > 0 ? params : undefined;
}

class AdminSubscriptionTransactionsService extends BaseService {
  private readonly basePath = "/admin/subscriptions/transactions";

  constructor() {
    super();
  }

  getTransactions(
    filters?: AdminSubscriptionTransactionFilters,
  ): Promise<AdminSubscriptionTransactionListResponse> {
    return this.get<AdminSubscriptionTransactionListResponse>(
      this.basePath,
      toQueryParams(filters),
    );
  }
}

export const adminSubscriptionTransactionsService =
  new AdminSubscriptionTransactionsService();
